import React, { useEffect, useState } from "react";
import DenseAppBar from "../../components/AppBar";
import MetricsCard from "../../components/MetricsCard";
import { useHistory } from "react-router-dom";
import FloatMatric from "../../components/floatMatric";
import PrimaryTheme from "../../Themes/Primary";
import FloatFinanceFilter from "../../components/floatFinanceFilter";
import FloatFinanceTable from "../../components/FloatFinanceTable";
import { Reducers } from "../../Interfaces/Interfaces";
import { useDispatch, useSelector } from "react-redux";
import {
  floatFinanaceAction,
  getFloatRequestFilterDashboard,
} from "../../redux/actions/FloatFinanceAction";
import AlertModal from "../../components/Modal";
import RecommentdAndDeclineForm from "../../components/RecommentdAndDeclineForm";
import FloatAlert from "../../components/FloatAlert";
import Placeholder from "../../components/Skeleton";
import RecAndDecBtn from "../../components/RecAndDecBtn";
import { getCurrency, getDateTime } from "../../helpers/Functions";
import PaginationControlled from "../../components/Pagination";
import Filters from "../../components/Filters";
import "./floatFinance.scss";
export default function FloatFinance(MetricsCardProps: any) {
  const daysCountReducer = useSelector((state: any) => state.daysCountReducer);
  const user = useSelector((state: Reducers) => state.user);
  const recAndDeclineMessageReducer = useSelector(
    (state: any) => state.recAndDeclineMessageReducer
  );
  const floatFinance = useSelector((state: any) => state.floatFinance);
  const alert = useSelector((state: Reducers) => state.alert);
  const [requestLoading, setrequestLoading] = React.useState(false);
  const loader = useSelector((state: Reducers) => state.internalLoader);
  const requestDashboardReducer = useSelector(
    (state: any) => state.requestDashboardReducer
  );

  let list: any = [];

  const [initDay, setinitDay] = useState({
    REQUESTS: "350",
    APPROVED: "30",
    DEFAULTS: "302",
  });
  const history = useHistory();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [searchState, setSearchState] = React.useState("");
  const [requestPeriod, setrequestPeriod] = React.useState(1);
  const [period, setperiod] = React.useState(1);
  const [approvePeriod, setapprovePeriod] = React.useState(1);
  const [approveLoading, setapproveLoading] = React.useState(false);
  const [defaultPeriod, setdefaultPeriod] = React.useState(1);
  const [defaultLoading, setdefaultLoading] = React.useState(false);
  let filter: any = {};
  let filter1 = { period };
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };
  const callFloatFinance = () => {
    dispatch(floatFinanaceAction(paginationConfig));
  };

  const handleChangeF = (value: any, type: string) => {
    switch (type) {
      case "request": {
        setrequestLoading(true);
        setrequestPeriod(value);
        setperiod(value);
        break;
      }
      case "approve": {
        setapproveLoading(true);
        setapprovePeriod(value);
        setperiod(value);
        break;
      }
      case "default": {
        setdefaultLoading(true);
        setdefaultPeriod(value);
        setperiod(value);
        break;
      }

      default:
        return;
    }
  };
  React.useEffect(() => {
    if (!loader) {
      setrequestLoading(false);
      setapproveLoading(false);
      setdefaultLoading(false);
    }
  }, [loader]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });

    // setrequestLoading(false);

    dispatch(getFloatRequestFilterDashboard(JSON.stringify(filter1)));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, defaultPeriod]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });

    // setrequestLoading(false);

    dispatch(getFloatRequestFilterDashboard(JSON.stringify(filter1)));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, requestPeriod]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });

    // setrequestLoading(false);

    dispatch(getFloatRequestFilterDashboard(JSON.stringify(filter1)));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, approvePeriod]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getTransactionSummary(user.id));
    callFloatFinance();
    return () => {
      dispatch({
        type: "FINANCE_TABLE_DATA",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  const handleRouteDetails = (details: any) => {
    console.log(details);
    history.push("/float-finance/details/" + details.id);
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);
    dispatch({ type: "LOADING", payload: true });
    paginationConfig.pageSize = value.props.value;
    // callTransactions();
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };
  React.useEffect(() => {
    if (searchState.length >= 3) {
      filter.agentName = searchState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });
      callFloatFinance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, searchState]);

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    // setAmount('');
    // setTypeStateChange(0);
    // setTransactionStatus(0);
    // setSearchState('');

    dispatch({
      type: "LOADING",
      payload: true,
    });
    callFloatFinance();
    // dispatch(getPOSDashboard(user.id));
  };

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        // enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        callFloatFinance();
        // enqueueSnackbar(alert.message, { variant: "success" });

        // handleRefresh();

        // dispatch({
        //   type: 'LOADING',
        //   payload: false
        // })

        // dispatch({
        //   type: 'ALERT',
        //   payload: {}
        // });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, alert, history]);

  return (
    <div>
      <AlertModal>
        {Object.keys(recAndDeclineMessageReducer).length === 0 ? (
          <RecommentdAndDeclineForm />
        ) : (
          <FloatAlert />
        )}
        {/* <FloatAlert /> */}
      </AlertModal>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          // height: '100vh',
        }}
      >
        <div className="row m-0">
          <div
            className="col-md-12 p-0"
            style={{
              backgroundColor: PrimaryTheme.white,
              height: "100vh",
              position: "relative",
              // zIndex: 1000,
            }}
          >
            <div className="col-md-11 ml-auto mr-auto p-0">
              <div className="row m-0 mb-4">
                <div
                  className="col-md-12 content-area p-0"
                  style={{
                    backgroundColor: PrimaryTheme.white,
                    height: "auto",
                    position: "relative",
                  }}
                >
                  <div className="row">
                    <div className="col-md-9 col-6">
                      <h4
                        className="float-title"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                        }}
                      >
                        FLOAT/FINANCE
                      </h4>
                    </div>
                    <div className="col-6 col-md-3"></div>
                  </div>
                </div>
              </div>

              {/* cards  */}
              <div className="row mb-5">
                <div
                  className="col-md-4"
                  style={{
                    height: "auto",
                    position: "relative",
                  }}
                >
                  <MetricsCard
                    id="first"
                    title="REQUESTS"
                    isLoading={requestLoading}
                    onMenuChange={(e: any) =>
                      handleChangeF(e.target.value, "request")
                    }
                    buttonTitle="."
                    hasMenu
                    hasButton
                    value={
                      JSON.stringify(
                        requestDashboardReducer.numberOfLoanRequests
                      )
                        ? requestDashboardReducer.numberOfLoanRequests.toLocaleString()
                        : "0"
                    }
                    buttonColor={PrimaryTheme.white}
                  />
                </div>

                <div
                  className="col-md-4"
                  style={{
                    height: "auto",
                    position: "relative",
                  }}
                >
                  <MetricsCard
                    id="second"
                    title="APPROVED
                                        
                      "
                    isLoading={approveLoading}
                    onMenuChange={(e: any) =>
                      handleChangeF(e.target.value, "approve")
                    }
                    value={
                      JSON.stringify(
                        requestDashboardReducer.numberOfApprovedLoans
                      )
                        ? requestDashboardReducer.numberOfApprovedLoans.toLocaleString()
                        : "0"
                    }
                    buttonTitle="."
                    hasMenu
                    hasButton
                    buttonColor={PrimaryTheme.white}
                  />
                </div>

                <div
                  className="col-md-4"
                  style={{
                    height: "auto",
                    position: "relative",
                  }}
                >
                  <MetricsCard
                    id="second"
                    title="DEFAULTS


                      "
                    isLoading={defaultLoading}
                    onMenuChange={(e: any) =>
                      handleChangeF(e.target.value, "default")
                    }
                    value={
                      JSON.stringify(requestDashboardReducer.numberOfDefaulters)
                        ? requestDashboardReducer.numberOfDefaulters.toLocaleString()
                        : "0"
                    }
                    buttonTitle="."
                    hasMenu
                    hasButton
                    buttonColor={PrimaryTheme.white}
                  />
                </div>
              </div>

              <Filters
                hasSearch
                searchState={searchState}
                onClear={handleClear}
                handleSearch={(e: any) => setSearchState(e.target.value)}
              />

              {/* <FloatFinanceFilter type={getType} /> */}
            </div>

            <div className="col-md-12  mb-3" style={{ paddingBottom: "150px" }}>
              {floatFinance ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th scope="col">S/N</th>
                          <th scope="col">AGENT ID</th>
                          <th scope="col">AGENT NAME</th>
                          <th scope="col">Approved Date</th>
                          <th scope="col">Repayment Date</th>
                          <th scope="col">TYPE</th>
                          <th scope="col">AMOUNT</th>
                          <th scope="col">ACTION </th>
                          <th scope="col">STATUS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {floatFinance && floatFinance.message ? (
                          floatFinance.message.items.map(
                            (item: any, index: number) => (
                              <tr
                                title="Click to view"
                                key={index}
                                className="pointer text-center"
                              >
                                <th
                                  scope="row"
                                  onClick={() => handleRouteDetails(item)}
                                >
                                  {getIndexSeed(index)}
                                </th>

                                <td onClick={() => handleRouteDetails(item)}>
                                  {item.agentId ? item.phoneNumber : "-"}
                                </td>
                                <td onClick={() => handleRouteDetails(item)}>
                                  {item.agentName ? item.agentName : "-"}
                                </td>
                                <td onClick={() => handleRouteDetails(item)}>
                                  {item.isApproved
                                    ? getDateTime(item.isApproved)
                                    : "-"}
                                </td>
                                <td onClick={() => handleRouteDetails(item)}>
                                  {item.expectedRepaymentDate
                                    ? getDateTime(item.expectedRepaymentDate)
                                    : "-"}
                                </td>

                                <td onClick={() => handleRouteDetails(item)}>
                                  {item.loanName ? item.loanName : "-"}
                                </td>
                                <td onClick={() => handleRouteDetails(item)}>
                                  {item.amountRequested
                                    ? getCurrency(item.amountRequested)
                                    : "-"}
                                </td>

                                <td>
                                  <RecAndDecBtn itemRecord={{ ...item }} />
                                </td>
                                <td onClick={() => handleRouteDetails(item)}>
                                  {item.applicationStatusName ? (
                                    item.applicationStatusName === "Repaid" ? (
                                      <button
                                        style={{
                                          background: "#278456",
                                          paddingTop: "10px",
                                          paddingBottom: "10px",
                                          paddingLeft: "24px",
                                          paddingRight: "24px",
                                          borderRadius: "100px",
                                          border: "none",
                                          color: "white",
                                        }}
                                      >
                                        {item.applicationStatusName}
                                      </button>
                                    ) : item.applicationStatusName ===
                                        "Declined" ||
                                      item.applicationStatusName ===
                                        "Behind" ? (
                                      <button
                                        style={{
                                          background: PrimaryTheme.danger,
                                          paddingTop: "10px",
                                          paddingBottom: "10px",
                                          paddingLeft: "24px",
                                          paddingRight: "24px",
                                          borderRadius: "100px",
                                          border: "none",
                                          color: "white",
                                        }}
                                      >
                                        {item.applicationStatusName}
                                      </button>
                                    ) : item.applicationStatusName ===
                                      "Pending" ? (
                                      <button
                                        style={{
                                          background: "#c49d52",
                                          paddingTop: "10px",
                                          paddingBottom: "10px",
                                          paddingLeft: "24px",
                                          paddingRight: "24px",
                                          borderRadius: "100px",
                                          border: "none",
                                          color: "white",
                                        }}
                                      >
                                        {item.applicationStatusName}
                                      </button>
                                    ) : (
                                      <button
                                        style={{
                                          background: PrimaryTheme.primary,
                                          paddingTop: "10px",
                                          paddingBottom: "10px",
                                          paddingLeft: "24px",
                                          paddingRight: "24px",
                                          borderRadius: "100px",
                                          border: "none",
                                          color: "white",
                                        }}
                                      >
                                        {item.applicationStatusName}
                                      </button>
                                    )
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>
                            )
                          )
                        ) : (
                          <React.Fragment>
                            <p className="text-center mt-3 text-dark w-100">
                              No result
                            </p>
                          </React.Fragment>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {floatFinance && floatFinance.message ? (
                    <div className="col-md-12 p-0">
                      {floatFinance.message.total > pageSize && (
                        <PaginationControlled
                          onPageSizeChange={handlePageSizeChange}
                          onChange={handleChange}
                          page={page}
                          total={
                            floatFinance.message.total &&
                            floatFinance.message.total
                          }
                          pageSize={pageSize}
                        />
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}

              {/* <React.Fragment>
                    <div className="col-md-12 text-center">

                        <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                    </div>
                    <div className="col-md-12 text-center">
                        <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                    </div>
                    <div className="col-md-12 text-center">
                        <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                    </div>

                </React.Fragment> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
